import { Box, Button, Grid, InputLabel, MenuItem, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import CustomSnackbar from '../../newTestPreo/components/snackbar/Snackbar';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

function RequestCallBack( {onClose}) {
    const enquiryId = localStorage.getItem('enquiryId')
    const enquiryPersonalDetailId = localStorage.getItem("enquiryPersonalDetailId");
    const { control, handleSubmit, formState: { errors } } = useForm();
    const [countries, setCountries] = useState([]);
    const [branches, setBranches] = useState([]);
    const [subServices, setSubServices] = useState([]);
    const [open, setOpen] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [contact, setContact] = useState('');
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [useremail, setUserEmail] = useState('');
    const [testType, setTestType] = useState('');
    const [deliveryMode, setDeliveryMode] = useState('');
    const [additionalInfo, setAdditionalInfo] = useState('');

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    
        const showSnackbar = (message, severity) => {
            setSnackbarMessage(message);
            setSnackbarSeverity(severity);
            setSnackbarOpen(true);
        };

    const onSubmit = async (data) => {
        data.service_id = 1

        if(enquiryPersonalDetailId) {
            data.enquiry_personal_detail_id = parseInt(enquiryPersonalDetailId);
        }

             try{ 

         const response = await fetch(`${API_ENDPOINT}requestcallback`, {
           method: 'POST', 
           headers: {
             'Content-Type': 'application/json', // Replace with the appropriate content type
           },
           body: JSON.stringify(data),
         })
          // .then((response) => {
             if (response.status === 201) {
               // API call succeeded, show success message
              // alert('Enquiry sent successfully');
              showSnackbar('Request sent successfully', 'success');
        
               setTimeout(() => {
                onClose()
               }, 3000);
             
               
             } else {
               // API call failed, show error message
              // alert('Error submitting enquiry. Please try again.');
              showSnackbar('Error submitting request. Please try again.', 'error');
             }
           }
           catch (error) {
             // Handle network errors or other issues
             console.error('Error:', error);
            // alert('An error occurred. Please try again later.');
            showSnackbar('An error occurred. Please try again later.', 'error');
         
       }
     };

  // Fetching country code
  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}countries`)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = [...data].sort(
          (a, b) => a.phone_code - b.phone_code
        );
        const uniqueArray = sortedData.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.phone_code === obj.phone_code)
        );

        setCountries(uniqueArray);
       
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

    useEffect(() => {
        // Fetch menu items using the fetch function
        fetch(`${API_ENDPOINT}route/branch`)
          .then(response => response.json())
          .then(data => {
            setBranches(data);
            
          })
          .catch(error => {
            console.error('Error fetching branches:', error);
          });
      }, []);

      useEffect(() => {
        // Fetch menu items using the fetch function
        fetch(`${API_ENDPOINT}route/subservice`)
          .then(response => response.json())
          .then(data => {
            setSubServices(data);
         
          })
          .catch(error => {
            console.error('Error fetching testtypes:', error);
          });
      }, []);

  return (
    <>
    
    <form onSubmit={handleSubmit(onSubmit)}>
       {enquiryPersonalDetailId ? (
        <>
         
            {/* Render inputs specific to enquiry ID */}
            <Grid item xs={6} md={4} lg={4}>
              <InputLabel style={{ color: 'black' }}>Exam Service
              <span style={{ color: 'red', position: 'absolute', marginLeft: '4px', fontSize: '1.5em' }}>*</span>
              </InputLabel>
              <Controller
                name='sub_service_id'
                control={control}
                rules={{ required: 'Exam Service is required' }}
                render={({ field }) => (
                  <TextField
                    select
                    {...field}
                    InputProps={{
                      style: { borderRadius: '12px' },
                    }}
                    fullWidth
                    error={Boolean(errors.sub_service_id)}
                  >
                    {subServices.map((service) => (
                      <MenuItem key={service.id} value={service.id}>{service.name}</MenuItem>
                    ))}
                  </TextField>
                )}
              />
              {errors.sub_service_id && (
                <span style={{ color: 'red' }}>
                  {errors.sub_service_id.message}
                </span>
              )}
            </Grid>

            <Grid item xs={6} md={4} lg={4}>
              <InputLabel style={{ color: 'black' }}>
                SIEC Nearest Branch
                <span style={{ color: 'red', position: 'absolute', marginLeft: '4px', fontSize: '1.5em' }}>*</span>
                </InputLabel>
              <Controller
                name='nearest_branch_id'
                control={control}
                rules={{ required: 'Branch name is required' }}
                render={({ field }) => (
                  <TextField
                    select
                    {...field}
                    InputProps={{
                      style: { borderRadius: '12px' },
                    }}
                    fullWidth
                    error={Boolean(errors.nearest_branch_id)}
                  >
                    {branches.map((branch) => (
                      <MenuItem key={branch.id} value={branch.id}>{branch.branch_name}</MenuItem>
                    ))}
                  </TextField>
                )}
              />
              {errors.nearest_branch_id && (
                <span style={{ color: 'red' }}>
                  {errors.nearest_branch_id.message}
                </span>
              )}
            </Grid>

            <Grid item xs={6} md={4} lg={4}>
              <InputLabel style={{ color: 'black' }}>Additional Information/ Requirements</InputLabel>
              <Controller
                name='note'
                control={control}
                render={({ field }) => (
                  <TextField
                    multiline
                    rows={4}
                    fullWidth
                    {...field}
                    InputProps={{
                      style: { borderRadius: '12px' },
                    }}
                    error={Boolean(errors.note)}
                  />
                )}
              />
              {errors.note && (
                <span style={{ color: 'red' }}>
                  {errors.note.message}
                </span>
              )}
            </Grid>
          </>
        ) : (
            <>
             <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                <InputLabel style={{ color: 'black', position: 'relative' }}>
                    First Name
                    <span style={{ color: 'red', position: 'absolute', marginLeft: '4px', fontSize: '1.5em' }}>*</span>
                    </InputLabel>
                <Controller
                  name='first_name'
                  control={control}
                  //rules={{ required: true }}
                 rules={{ required: 'First name is required' }} 
                  render={({ field }) => {
               
                    return (
                      <TextField
                        {...field}
                        fullWidth 
                        InputProps={{
                          style: { borderRadius: '12px' },
                        }}
                        error={!!errors.first_name}
                      />
                    );
                  }}
                
                />
                {errors.first_name && (
                    <span style={{ color: 'red' }}>
                    {errors.first_name.message} 
                    </span>
                )}
                </Grid>

               
                 <Grid item xs={12} md={6} lg={6}>
                 <InputLabel style={{ color: 'black' }}>Last Name</InputLabel>
                <Controller
                  name='last_name'
                  control={control}
                  //rules={{ required: true }}
                 //rules={{ required: 'Last name is required' }}
                  render={({ field }) => (
                    
                    <TextField
                      {...field}
                      fullWidth
                      InputProps={{
                        style: { borderRadius: '12px' },
                      }}
                      error={!!errors.last_name}
                      //helperText={errors.last_name && 'Last name is required'}
                    />
                  )}
                />
                {errors.last_name && (
                <span style={{ color: 'red'}}>
                {errors.last_name.message}
                </span>
            )}
              </Grid>
              </Grid>

      
              
              <Grid item xs={12} md={12} lg={12} container>

                <Grid item xs={4} md={4} lg={4}>
                <InputLabel style={{ color: 'black', position: 'relative' }}>
                  ISD Code
                  <span style={{ color: 'red', position: 'absolute', marginLeft: '4px', fontSize: '1.5em' }}>*</span>
                </InputLabel>
                <Controller
                  name='mobile_country_code'
                  control={control}
                  defaultValue={91}
                  rules={{ required: "Country code is required" }}
                  render={({ field }) => (
                    <TextField
                      select
                      {...field}
                      InputProps={{
                        style: { borderRadius: '12px' },
                      }}
                      fullWidth
                      defaultValue={91}
                      error={Boolean(errors.mobile_country_code)}
                    >
                      {countries.map((country) => (
                        <MenuItem key={country.phone_code} value={country.phone_code}>+{country.phone_code}</MenuItem>
                      ))}
                    </TextField>
                  )}
                />
                {errors.mobile_country_code && (
                  <span style={{ color: 'red'}}>
                    {errors.mobile_country_code.message} 
                  </span>
                )}
              </Grid>
              <Grid item xs={8}>
                <InputLabel style={{ color: 'black', position: 'relative' }}>
                  Mobile
                  <span style={{ color: 'red', position: 'absolute', marginLeft: '4px', fontSize: '1.5em' }}>*</span>
                </InputLabel>
                <Controller 
                  name="mobile"
                  control={control}
                  rules={{ 
                    required: "Contact number is required",
                    pattern: {
                      value: /^[1-9][0-9]{9}$/,
                      message: "Invalid mobile number."
                    }
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      InputProps={{
                        style: { borderRadius: '12px' },
                      }}
                      error={!!errors.mobile}
                      fullWidth
                    />
                  )}
                />
                {errors.mobile && (
                  <span style={{ color: 'red'}}>
                    {errors.mobile.message} 
                  </span>
                )}
              </Grid>
              </Grid>

              <Grid item xs={6} md={4} lg={4}>
                            <InputLabel style={{ color: 'black', position: 'relative' }}>
                                Email
                                <span style={{ color: 'red', position: 'absolute', marginLeft: '4px', fontSize: '1.5em' }}>*</span>
                                </InputLabel>
                            <Controller
                                name="email"
                                control={control}
                                rules={{ 
                                    required: "Email is required", 
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                        message: "Invalid email address",
                                    },
                                }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        InputProps={{
                                            style: { borderRadius: '12px' },
                                            }}
                                        variant="outlined"
                                        error={!!errors.email}
                                        fullWidth
                                        />
                                )}
                                ></Controller>
                                {errors.email && (
                                    <span style={{ color: 'red'}}>
                                    {errors.email.message} 
                                    </span>
                                )}
                            </Grid>

                            <Grid item xs={6} md={4} lg={3}>
                                <InputLabel style={{ color: 'black', position: 'relative' }}>
                                    Exam Service
                                    <span style={{ color: 'red', position: 'absolute', marginLeft: '4px', fontSize: '1.5em' }}>*</span>
                                    </InputLabel>
                                    <Controller
                                    name='sub_service_id'
                                    control={control}
                                    rules={{ required: "Exam Service is required" }}
                                    render={({ field }) => (
                                        <TextField
                                        select
                                        {...field}
                                        InputProps={{
                                            style: { borderRadius: '12px' },
                                        }}
                                        fullWidth
                                       // defaultValue='test prep'
                                        error={Boolean(errors.sub_service_id)}
                                        //helperText={errors.service_name}
                                        >
                                       {subServices.map((service) => (
                                        <MenuItem key={service.id} value={service.id}>{service.name}</MenuItem>
                                       ))}
                                       
                                        </TextField>
                                    )}
                                    />
                                     {errors.sub_service_id && (
                                        <span style={{ color: 'red'}}>
                                        {errors.sub_service_id.message}
                                        </span>
                                    )}
                                </Grid>

                            <Grid item xs={6} md={4} lg={3}>
                                <InputLabel style={{ color: 'black' }} >SIEC Nearest Branch</InputLabel>
                                    <Controller
                                    name='nearest_branch_id'
                                    control={control}
                                    rules={{ required: "Branch name is required" }}
                                    render={({ field }) => (
                                        <TextField
                                        select
                                        {...field}
                                        //value={nearest_branch}
                                        InputProps={{
                                            style: { borderRadius: '12px' },
                                        }}
                                        fullWidth
                                       
                                        error={Boolean(errors.nearest_branch_id)}
                                       // onChange={(event) => setNearestBranch(event.target.value)}
                                       // helperText={errors.nearest_branch && 'Branch Name is required'}
                                        >
                                       {branches.map((branch) => (
                                        <MenuItem key={branch.id} value={branch.id}>{branch.branch_name}</MenuItem>
                                       ))}
                                        </TextField>
                                    )}
                                    />
                                    {errors.nearest_branch_id && (
                                        <span style={{ color: 'red'}}>
                                        {errors.nearest_branch_id.message}
                                        </span>
                                    )}
                                </Grid>

                                <Grid item xs={6} md={4} lg={3}>
                                <InputLabel style={{ color: 'black' }} >Additional Information/ Requirements</InputLabel>
                                    <Controller
                                    name='note'
                                    control={control}
                                    //rules={{ required: "Branch name is required" }}
                                    render={({ field }) => (
                                        <TextField
                                        multiline
                                        rows={4}
                                        fullWidth
                                        {...field}
                                        //value={nearest_branch}
                                        InputProps={{
                                            style: { borderRadius: '12px' },
                                        }}
                                        
                                       
                                        error={Boolean(errors.note)}
                                       // onChange={(event) => setNearestBranch(event.target.value)}
                                       // helperText={errors.nearest_branch && 'Branch Name is required'}
                                        >
                                        </TextField>
                                    )}
                                    />
                                    {errors.note && (
                                        <span style={{ color: 'red'}}>
                                        {errors.note.message}
                                        </span>
                                    )}
                                </Grid>
                                </>
        )}
    
      <Button type="submit" variant="contained" color="primary">
        Submit Request
      </Button>
       </form>

        <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
        /> 
        </>
  )
}

export default RequestCallBack